import { createStore } from 'satcheljs';
export default createStore('attachmentPreferencesOption', {
    fromComputer: null,
    fromOneDrive: null,
})();
//# sourceMappingURL=store.js.map